import "./App.css";
import { TbArrowBigTop } from "react-icons/tb";
import About from "./components/About/About";
import Contact from "./components/Contacts/Contact";
import Footer from "./components/Footer/Footer";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar/Navbar";
import Services from "./components/Services/Services";
import Tools from "./components/Tools/Tools";
import Video from "./components/Video/Video";

function App() {
  return (
    <div className="App">
      <div>
        <Navbar />
        <Hero />
        <About />
        <Services />
        <Video />
        <Tools />
        <Contact />
        <Footer />
      </div>
      {/* <div className="restart-icon">
        <TbArrowBigTop color="white" size={30} />
      </div> */}
    </div>
  );
}

export default App;
